import { useEffect } from 'react';
const PIXEL_ID = '1555763442913803';
export function MetaPixel() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const w = window as unknown as {
      fbq?: (...args: unknown[]) => void;
      _fbq?: unknown;
    };
    if (w.fbq) {
      w.fbq('track', 'PageView');
      return;
    }

    /* eslint-disable */
    (function (f: any, b, e, v, n?: any, t?: any, s?: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = true;
      t.src = v;
      s = b.getElementsByTagName(e)[0];

      // Magic Patterns previews may not include any script tag yet.
      // Insert safely so tracking never prevents the app from rendering.
      if (s?.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else if (b.head) {
        b.head.appendChild(t);
      } else {
        b.documentElement.appendChild(t);
      }
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    /* eslint-enable */

    w.fbq!('init', PIXEL_ID);
    w.fbq!('track', 'PageView');
  }, []);
  return null;
}